{
    "name": "Siemens Theme Light Medium",
    "$schema": "./reportThemeSchema-2.114.json",
    "dataColors": [
        "#6CAEFF",
        "#F05D8F",
        "#F19E6A"
    ],
    "background": "#FFFFFF",
    "foreground": "#404040",
    "tableAccent": "#BFBFBF",
    "good": "#009A38",
    "neutral": "#FFD200",
    "bad": "#E7001D",
    "maximum": "#F9B591",
    "center": "#FBD2BD",
    "minimum": "#FDF0E9",
    "textClasses": {
        "title": {
            "fontSize": 10.5,
            "fontFace": "Siemens Sans",
            "color": "#000000"
        },
        "label": {
            "fontFace": "Siemens Sans",
            "fontSize": 10.5
        },
        "callout": {
            "fontFace": "Siemens Sans",
            "fontSize": 10.5
        },
        "header": {
            "fontFace": "Siemens Sans",
            "fontSize": 10.5
        }
    },
    "visualStyles": {
        "*": {
            "*": {
                "visualHeader": [
                    {
                        "show": true
                    }
                ],
                "title": [
                    {
                        "show": true,
                        "fontFace": "Siemens Sans",
                        "fontColor": {
                            "solid": {
                                "color": "#000000"
                            }
                        },
                        "wordWrap": false,
                        "fontSize": 10.5,
                        "bold": true,
                        "heading": {
                            "type": "string",
                            "oneOf": [
                                {
                                    "const": "Normal",
                                    "title": "Normal"
                                }
                            ]
                        }
                    }
                ],
                "legend": [
                    {
                        "show": true,
                        "position": "TopCenter",
                        "showTitle": false,
                        "labelColor": {
                            "solid": {
                                "color": "#7D7D7D"
                            }
                        },
                        "fontSize": 10.5,
                        "legendMarkerRendering": "markerOnly",
                        "matchLineColor": false
                    }
                ],
                "valueAxis": [
                    {
                        "show": true,
                        "gridlineShow": true,
                        "gridlineColor": {
                            "solid": {
                                "color": "#F5F5F5"
                            }
                        },
                        "gridlineThickness": 2,
                        "gridlineStyle": "solid",
                        "showAxisTitle": false
                    }
                ],
                "categoryAxis": [
                    {
                        "show": true,
                        "gridlineShow": false,
                        "showAxisTitle": false
                    }
                ],
                "outspacePane": [
                    {
                        "backgroundColor": {
                            "solid": {
                                "color": "#FFFFFF"
                            }
                        },
                        "transparency": 0
                    }
                ]
            }
        },
        "textbox": {
            "*": {
                "*": [
                    {
                        "fontSize": 10.5,
                        "fontFamily": "Siemens Sans",
                        "wordWrap": true,
                        "color": {
                            "solid": {
                                "color": "#000000"
                            }
                        }
                    }
                ],
                "visualHeader": [
                    {
                        "show": false
                    }
                ],
                "background": [
                    {
                        "show": true,
                        "color": {
                            "solid": {
                                "color": "#DDDDDD"
                            }
                        },
                        "transparency": 100
                    }
                ]
            }
        },
        "page": {
            "*": {
                "background": [
                    {
                        "color": {
                            "solid": {
                                "color": "#FFFFFF"
                            }
                        },
                        "transparency": 100
                    }
                ]
            }
        }
    }
}